import { ROOT_HIERARCHY_ID } from 'constants/hierarchy';

import { EntitiesState } from './types';

export const initialState: EntitiesState = {
  predefinedTemplates: {},
  entities: {},
  hierarchy: { id: ROOT_HIERARCHY_ID, children: [] },
  counters: {},
  stash: { entities: {} },
};
